module.exports = __webpack_public_path__ + "imgs/adilas.45ed9405a6cc7f6e54ecfd33fc2bea79.jpg";